import { frontendURL } from '../../../../helper/URLHelper';

const orders = accountId => ({
  parentNav: 'orders',
  routes: ['orders_list', 'orders_details', 'orders_segments_index'],
  menuItems: [
    {
      icon: 'cart',
      label: 'ORDERS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/orders`),
      toStateName: 'orders_list',
    },
    {
      icon: 'contact-card-group',
      label: 'CUSTOM_VIEWS_SEGMENTS',
      hasSubMenu: true,
      children: [],
    },
  ],
});

export default orders; 